const { formatText } = require('core/i18n').i18n;

const getUnpaidFees = () => {
    return {
        STATE_TYPES: {
            PA: formatText('mortgageRequestDuesPayments-stateTypePA'),
            PP: formatText('mortgageRequestDuesPayments-stateTypePP'),
            IP: formatText('mortgageRequestDuesPayments-stateTypeIP'),
            PC: formatText('mortgageRequestDuesPayments-stateTypePC'),
            TR: formatText('mortgageRequestDuesPayments-stateTypeTR'),
        },
        SITUATION_TYPES: {
            IP: formatText('mortgageRequestDuesPayments-situationTypeIP'),
            RT: formatText('mortgageRequestDuesPayments-situationTypeRT'),
            AN: formatText('mortgageRequestDuesPayments-situationTypeAN'),
            EJ: formatText('mortgageRequestDuesPayments-situationTypeEJ'),
            PA: formatText('mortgageRequestDuesPayments-situationTypePA'),
            EN: formatText('mortgageRequestDuesPayments-situationTypeEN'),
            PL: formatText('mortgageRequestDuesPayments-situationTypePL')
        }
    }
};

module.exports = {
    getUnpaidFees
};